import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { ProfilePicture } from 'inside-out/components/support-organisations/profilePicture';
import LocationIcon from 'inside-out/images/location-icon-small.svg';
import {
	wrapperStyle,
	metaAudiencesStyle,
	organisationStyle,
	wrapperLinkStyle,
	titleStyle,
	bodyStyle,
	lozengeStyle,
	innerStyleOrganisation,
	innerStyleIndividual,
} from './styles';

import { mobileMaxWidthBreakpoint } from 'inside-out/global-styles';

class SupportCardComponent extends React.PureComponent {
	render() {
		const { to, organisation, location, image, audiences, title, body, type } = this.props;

		return (
			<Link className={wrapperLinkStyle} to={to} data-component="Card">
				<article className={wrapperStyle}>
					<div>
						{type === 'organisation' &&
							image && (
								<div className={innerStyleOrganisation}>
									<img src={image} alt="" />
								</div>
							)}
						{type === 'individual' &&
							image && (
								<div className={innerStyleIndividual}>
									<ProfilePicture
										image={image}
										size={130}
										sizesAt={{
											[mobileMaxWidthBreakpoint]: 80,
										}}
									/>
								</div>
							)}
					</div>
					<div>
						<h1 className={titleStyle}>{title}</h1>

						<div className={organisationStyle}>
							<span>
								{organisation} <img src={LocationIcon} alt="" /> {location}
							</span>
						</div>
						<div className={metaAudiencesStyle}>
							{audiences.map((audience, i) => (
								<span key={i} className={lozengeStyle(audience.id)}>
									{audience.title}
								</span>
							))}
						</div>

						<p className={bodyStyle}>{body}</p>
					</div>
				</article>
			</Link>
		);
	}
}

SupportCardComponent.propTypes = {
	to: PropTypes.string,
	type: PropTypes.string,
	category: PropTypes.string,
	audiences: PropTypes.array,
	title: PropTypes.string,
	body: PropTypes.string,
	image: PropTypes.string,
};

export const SupportCard = SupportCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/supportCard/component.js